<div class="home-page-card-footer-container">
  <div
    [@detailExpand]="learnMoreExpanded ? 'expanded' : 'collapsed'"
    class="home-page-card-learn-more-content  {{ !learnMoreExpanded ? 'closed' : '' }}"
  >
    <ng-content></ng-content>
    <div *ngIf="linkParams" class="row col-xs-12 col-md-8">
      <a (click)="linkClicked(linkParams.url)" [attr.data-action]="'footer-link'">
        <span>{{ linkParams.text | translate }}</span>
        <mat-icon class="link-icon">{{ linkParams.icon }}</mat-icon>
      </a>
    </div>
    <br />
  </div>
  <div class="home-page-card-footer">
    <div class="home-page-card-learn-more" (click)="handleLearnMoreToggleClicked()">
      <div *ngIf="!learnMoreExpanded; else showLess">
        <mat-icon *ngIf="expandable" class="home-page-card-learn-more-icon">expand_more</mat-icon>
        <span *ngIf="expandable">{{ showMoreText$ | async | translate }}</span>
      </div>
      <ng-template #showLess>
        <div>
          <mat-icon class="home-page-card-learn-more-icon">expand_less</mat-icon>
          <span>{{ showLessText$ | async | translate }}</span>
        </div>
      </ng-template>
    </div>
    <div class="home-page-card-footer-cta-container">
      <button
        *ngFor="let cta of ctaButtons"
        mat-stroked-button
        color="primary"
        class="home-page-card-footer-cta"
        data-action="cta.url"
        (click)="buttonClicked(cta)"
      >
        <div>{{ cta.text | translate }}</div>
      </button>
    </div>
  </div>
</div>
